module.exports = __webpack_public_path__ + "img/trending-image-thumb.c00fe246.jpg";